import getPaymentTypes from "./getPaymentTypes";
import store from "./store";
import getAll from "./getAll";
import update from "./update";
import destroy from "./destroy";
import changeStatus from "./changeStatus";
import getActionOccurs from "./getActionOccurs";

export default {
  getPaymentTypes,
  store,
  getAll,
  update,
  destroy,
  changeStatus,
  getActionOccurs
}



// WEBPACK FOOTER //
// ./src/app/services/schedule-payment/index.js